export const UK_MAP_LOCATION = {
  lng: -3.4360,
  lat: 55.3781,
}

export const CENTRAL_EUROPE_LOCATION = {
  lng: 14.9706,
  lat: 50.3785,
}
